import { List, Record } from "immutable";

import {
  LOAD_OBSERVATION_TYPES_SUCCESS,
  CREATE_OBSERVATION_TYPE_SUCCESS,
} from "./action-types";

export const ObservationTypesState = new Record({
  list: new List(),
});

export function observationTypesReducer(
  state = new ObservationTypesState(),
  { payload, type }
) {
  switch (type) {
    case LOAD_OBSERVATION_TYPES_SUCCESS:
      return state.set("list", new List(payload));

    case CREATE_OBSERVATION_TYPE_SUCCESS:
      return state.set("list", state.list.unshift(payload));

    default:
      return state;
  }
}
